import React, { useEffect, useState } from "react";
import AmenityCard from "./AminityCard.tsx";
import { amenities1, amenities2, amenities3, amenities4, amenities5, amenities6, amenities7, coupleroom, line } from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const amenities = [
  {
    title: "Couple Room",
    description:
      "Enjoy modern amenities such as a spacious ensuite bathroom, a cozy seating area, and in-room entertainment options. ",
    image: coupleroom,
    route: "/coupleroom",
  },
  {
    title: "Family Room",
    description:
      "One day stay with family ,Room provides facility of accommodating additional 2 persons over sofa cum bed.",
    image:amenities1,
    route: "/familyroompage",
  },
  {
    title: "Family Room for 2 days stay",
    description:
      "Comfortable bedding arrangements to accommodate your family s size, including options like double beds, bunk beds, or a combination of both.",
    image:amenities2,
    route: "/daysrentpage",
  },
  {
    title: "Honeymoon Sweet Room",
    description:
      "When designing amenities focused on privacy,  relaxation, and a sense of personal space. Here are some key amenities that enhance privacy:",
    image:amenities3,
    route: "/honeymoonpage",
  },
  {
    title: "Room with swimming pool",
    description:
      "The room features its own private swimming pool, often indoors for privacy and convenience. The pool could be designed for relaxation or even for exercise purposes.",
    image:amenities4,
    route: "/roomswimpage",
  },
  {
    title: "FamilyRoom swimming pool",
    description:
      "here are multiple bathrooms, ideally with en-suite facilities in each bedroom or shared few bedrooms, to ensure convenience and privacy.",
    image:amenities5,
    route: "/familyroomswinpage",
  },
  {
    title: "Group Room",
    description:
      "Nestled in a serene location surrounded by lush greenery & views, this family-friendly villa offers a perfect comfort,  memorable getaway with your loved ones.",
    image:amenities6,
    route: "/grouproompage",
  },
  {
    title: "Villa ",
    description:
      "A villa with a bonfire area offers a delightful combination of luxurious cozy outdoor gatherings around a crackling fire.villa is located at a very calm and peaceful place.",
    image:amenities7,
    route: "/fullvilla",
  },
];

const Amenities = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
        const footerSection2 = gsap.from(".gsapAmeneties", {
          opacity: 0,
          duration: 1,
          x: 500,
          scrollTrigger: {
            trigger: ".gsapAmeneties",
            scroller: "body",
            markers: false,
            start: "top 100%",
          },
        });
        ScrollTrigger.matchMedia({
          "(max-width: 800px)": function () {
            footerSection2.vars.x = 0;
          },
        });
    }
  });

  return (
    <div className="app" style={{ paddingTop: "60px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          className="img-size"
          style={{ width: "400px" }}
          src={line}
          alt=""
        />
        <h1
          style={{
            textAlign: "center",
            fontSize: "40px",
            padding: "26px 0px",
            margin: "0px 20px",
          }}
          className="titlesFontFamily"
        >
          Amenities & Services
        </h1>
        <img
          className="img-size"
          style={{ width: "400px" }}
          src={line}
          alt=""
        />
      </div>
      <div
        className="amenity-list gsapAmeneties"
        style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
      >
        {amenities.map((amenity) => (
          <AmenityCard
            title={amenity.title}
            description={amenity.description}
            image={amenity.image}
            route={amenity.route}
          />
        ))}
      </div>
    </div>
  );
};

export default Amenities;
